import { render } from "./ServiceItalianToEnglish.vue?vue&type=template&id=6a8c2908"
import script from "./ServiceItalianToEnglish.vue?vue&type=script&lang=js"
export * from "./ServiceItalianToEnglish.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__